import axios from 'axios'
import Store from '@/store/index'
// import cookie from 'js-cookie'
import MHNotify from '@/assets/js/MHNotify' // 使用 MHNotify 替代直接 Notification [Claude Code]
import utils from '@/assets/js/utils'
import apiTracker from '@/assets/js/apiPerformanceTracker' // API 响应时间采集 [Claude Code]
// import { checkRoleAndToken } from '@/axios/base'

export const createAxiosInstance = (serviceName = '') => {
  const service = axios.create()
  service.defaults.withCredentials = true
  service.interceptors.request.use(config => {
    config._startTime = Date.now() // 记录请求开始时间 [Claude Code]
    if (config.requestBase == 'FORM') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    } else if (config.method.toUpperCase() === 'POST') {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
    if (config.url.indexOf('/api/') > -1 && config.url.indexOf('/object-service/') == -1) {
      config.headers.Authorization = Store.state.operateObject.sessionId
      config.headers.tagvalue = Store.state.operateObject.tagValue
      config.withCredentials = false
    }
    return config
  }, error => {
    return Promise.reject(error)
  })
  service.interceptors.response.use(res => {
    // 采集成功请求耗时 [Claude Code]
    if (res.config._startTime) {
      const endTime = Date.now()
      apiTracker.addRecord({
        method: res.config.method,
        url: res.config.url,
        startTime: res.config._startTime,
        endTime,
        duration: endTime - res.config._startTime,
        status: res.status,
        success: true
      })
    }
    const data = serviceName == 'mediahub' ? res.data : res
    if (res.config.url.includes('/media-hub/') && res.headers.mid && (res.headers.mrole === '0' || res.headers.mrole === '1')) {
      Store.commit('setTvuUserInfo', {
        id: res.headers.mid,
        role: res.headers.mrole
      })
    }
    serviceName == 'mediahub' && utils.formatErrorInfo(res)
    return Promise.resolve(data)
  }, error => {
    // 采集失败请求耗时 [Claude Code]
    if (error.config && error.config._startTime) {
      const endTime = Date.now()
      apiTracker.addRecord({
        method: error.config.method,
        url: error.config.url,
        startTime: error.config._startTime,
        endTime,
        duration: endTime - error.config._startTime,
        status: error.response ? error.response.status : 0,
        success: false
      })
    }
    const errResult = error.response || {}
    // 从 axios config 中取语义化标题 [Claude Code]
    const notifyTitle = error.config && error.config.notifyTitle
    if (errResult) {
      switch (errResult.status) {
        case 402:
        case 401:
        case 403:
          Store.dispatch('jumpLoginPage', error.config.url)
          break
        case 500:
          MHNotify({ title: notifyTitle ? `${notifyTitle} Failed` : 'Service Unavailable', message: 'Something went wrong on our end. Please try again in a moment. If the issue persists, contact support.', type: 'error' })
          break
        case 504:
          MHNotify({ title: notifyTitle ? `${notifyTitle} Failed` : 'Request Timeout', message: 'The server is taking too long to respond. Please check your connection and try again.', type: 'error' })
      }
    }
    return Promise.reject(errResult.data)
  })
  return service
}
export const request = createAxiosInstance('mediahub')
